module.exports = __webpack_public_path__ + "img/35_35.cd70ab95.png";